var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshRed = function SvgRefreshRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C83133",
    d: "M11.339 3.884C10.584 3.644 9.688 3.5 9 3.5a8.5 8.5 0 1 0 8.22 6.331 6.2 6.2 0 0 0-.666-1.55.5.5 0 0 0-.85.525q.338.548.553 1.291A7.5 7.5 0 1 1 9 4.5c.553 0 1.305.121 1.927.304.406.119.877-.772.412-.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C83133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.445.561 4.81 3.757L7.08 7.55"
  }))));
};
export default SvgRefreshRed;